import { configureStore } from '@reduxjs/toolkit';
import { sessionSlice as session } from './slices/session.slice';
import { errorSlice as error } from './slices/error.slice';
import { configurationSlice as configuration, saveConfiguration } from './slices/configuration.slice';
import { bankSlice as bank } from './slices/bank.slice';
import { authSlice as auth, saveAuthentication } from './slices/auth.slice';
import { BankAppConfiguration } from '../types/sdk';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { omit } from 'lodash';
import { accountSlice } from './slices/account.slice';
import { formSlice } from './slices/form.slice';
import { redirectionSlice } from './slices/redirection.slice';
import { exceptionSlice } from './slices/exception.slice';

export let store: ReturnType<typeof createStore>;

export interface CreateStoreParameters {
	configuration: BankAppConfiguration;
}

export const createStore = (parameters: CreateStoreParameters) => {
	const configuredStore = configureStore({
		reducer: {
			auth: auth.reducer,
			session: session.reducer,
			bank: bank.reducer,
			configuration: configuration.reducer,
			error: error.reducer,
			account: accountSlice.reducer,
			form: formSlice.reducer,
			redirection: redirectionSlice.reducer,
			exception: exceptionSlice.reducer
		}
	});

	const config = { ...parameters.configuration };

	delete config.callbacks;

	const dispatch = configuredStore.dispatch;
	dispatch(saveAuthentication(config));
	dispatch(saveConfiguration(omit(config, ['longTermToken', 'shortTermToken', 'inviteToken', 'url'])));

	store = configuredStore;
	return configuredStore;
};

export const setStore = (configuredStore: ToolkitStore) => {
	store = configuredStore;
};

export const getStore = () => store;

export type AppDispatch = ReturnType<typeof createStore>['dispatch'];
export type GetState = ReturnType<typeof createStore>['getState'];
export type RootState = ReturnType<GetState>;
